import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CATEGORY_LABELS } from "@/lib/format";
import { ArrowRight } from "lucide-react";

// A tile grid of sub-categories (Plumbing, Diving, Skincare…) so shoppers jump
// straight into the deep aisles from the top of the homepage.
export default function ShopBySubCategory() {
  const [tiles, setTiles] = useState([]);
  useEffect(() => {
    api.get("/categories").then(({ data }) => {
      const out = [];
      (data || []).forEach((c) => {
        (c.subcategories || []).forEach((s) => {
          out.push({ cat: c.slug, catName: CATEGORY_LABELS[c.slug] || c.name, sub: s.slug, subName: s.name });
        });
      });
      setTiles(out);
    }).catch(() => {});
  }, []);
  if (tiles.length < 4) return null;
  const shown = tiles.slice(0, 12);
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="shop-by-subcategory">
      <div className="mb-6">
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Shop by Sub-Category</h2>
        <p className="text-muted-foreground text-sm mt-1">Jump straight to the aisle you want.</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {shown.map((t) => (
          <Link
            key={`${t.cat}-${t.sub}`}
            to={`/category/${t.cat}?sub=${t.sub}`}
            data-testid={`subcat-tile-${t.cat}-${t.sub}`}
            className="group relative overflow-hidden rounded-2xl border border-border bg-card p-5 sn-card-hover flex items-center justify-between gap-3"
          >
            <div className="min-w-0">
              <div className="text-[11px] uppercase tracking-wider text-muted-foreground truncate">{t.catName}</div>
              <div className="font-display font-bold text-lg mt-0.5 truncate">{t.subName}</div>
            </div>
            <span className="h-9 w-9 shrink-0 grid place-items-center rounded-full bg-secondary text-ink group-hover:bg-coral group-hover:text-white transition-colors">
              <ArrowRight size={16} />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
